import { render } from "./VendorOrdersShowCardItems.vue?vue&type=template&id=5a27f94e"
import script from "./VendorOrdersShowCardItems.vue?vue&type=script&lang=js"
export * from "./VendorOrdersShowCardItems.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__